/* eslint-disable jsx-a11y/alt-text */
import * as React from "react";
import { SidingArea, SidingType, SidingColor, SidingSupportedConfigurations, imageUrlForColor } from "./colors";
import * as Resx from "./resources";
import * as _ from "lodash";
import { ColorizerControlPanel } from "./colorizer-control-panel";
import { ColorizerState, ConfiguredArea } from "./colorizer-state";
import { SelectionsList } from "./selections-list";

var Styles: { [key: string]: React.CSSProperties} = {
    FILL_CONTAINER: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    TRANSLUCENT: {
        opacity: 0.65
    },
    PANEL_A1: {
        right: "72%",
        bottom: "53%",
        height: "47%"
    },
    PANEL_A2: {
        left: "61.7%",
        bottom: "52.5%",
        height: "48%"
    },
    PANEL_B1: {
        left: "39%",
        right: "44%",
        bottom: "52.5%",
        height: "48%",
        width: "17%"
    },
    PANEL_C1: {
        top: "47.4%",
        height: "52.5%"
    },
    PANEL_C2: {
        left: "28.8%",
        right: "60.6%",
        bottom: "53%",
        height: "47%",
        width: "10.6%"
    },
    PANEL_C3: {
        left: "55.6%",
        right: "38.7%",
        bottom: "58%",
        height: "42%",
        width: "5.7%"
    },
    HIDE: {
        display: "none"
    }
}


/**
 * ColorizerCanvas is the current display of the house and all siding options.
 */
class ColorizerCanvas extends React.Component<ColorizerState, {}> {
    render() {
        let a = ColorizerState.configForArea(this.props, SidingArea.A);
        let b = ColorizerState.configForArea(this.props, SidingArea.B);
        let c = ColorizerState.configForArea(this.props, SidingArea.C);
        let trim = ColorizerState.configForArea(this.props, SidingArea.Trim);

        return (<div className="colorizer-canvas" >
            <img src={Resx.sidingUrlFor(a.SidingType, SidingArea.A)} style={Styles.FILL_CONTAINER}/>

            <img src={imageUrlForColor(a.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_A1)} />
            <img src={imageUrlForColor(a.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_A2)} />

            <img src={Resx.sidingUrlFor(b.SidingType, SidingArea.B)} style={Styles.FILL_CONTAINER}/>
            <img src={imageUrlForColor(b.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_B1)} />

            <img src={Resx.sidingUrlFor(c.SidingType, SidingArea.C)} style={Styles.FILL_CONTAINER}/>
            <img src={imageUrlForColor(c.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_C1)} />
            <img src={imageUrlForColor(c.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_C2)} />
            <img src={imageUrlForColor(c.SelectedColor, 50, 50)} style={_.extend({}, Styles.FILL_CONTAINER, Styles.TRANSLUCENT, Styles.PANEL_C3)} />

            <img src={Resx.urlFor("KlauerHouse.png")} style={Styles.FILL_CONTAINER}/>
            <img src={Resx.trimUrlFor(trim.SelectedColor)} style={Styles.FILL_CONTAINER}/>

            <nav className="helper one" >1.</nav>
            <nav className="helper two" >2.</nav>
            <nav className="helper three" >3.</nav>
            <nav className="helper four" >4.</nav>
        </div>);
    }
}


interface ColorizerOptions extends React.Props<ColorizerOptions> {
    baseUrl: string;
    configurations: SidingSupportedConfigurations[][];
    initialSelection: Number[];
}

/**
 * Component that facilitates the interaction between the the Display, the Control Panel,
 * and the selections list.
 */
export class Colorizer extends React.Component<ColorizerOptions, ColorizerState> {

    constructor(props: ColorizerOptions) {
        super(props);

        this.state = new ColorizerState(
            new ConfiguredArea(props.initialSelection[0] as SidingColor, SidingType.Trim),
            new ConfiguredArea(props.initialSelection[1] as SidingColor, props.initialSelection[2] as SidingType),
            new ConfiguredArea(props.initialSelection[3] as SidingColor, props.initialSelection[4] as SidingType),
            new ConfiguredArea(props.initialSelection[5] as SidingColor, props.initialSelection[6] as SidingType),
        );
    }

    onSettingsChanged(area: SidingArea, config: ConfiguredArea) {
        let currentState = this.state;
        ColorizerState.setConfigForArea(this.state, area, config);
        this.setState(currentState);

        window.history.replaceState(null, "", "#" + ColorizerState.codeFor(this.state));
    }

    render() {
        return (
            <div id="colorizer" className="" >
                <ColorizerCanvas {...this.state} />
                <ColorizerControlPanel areas={this.props.configurations} onSettingsChanged={this.onSettingsChanged.bind(this)} initialState={this.state} />
                <SelectionsList config={this.state} />
            </div>);
    }
}